/**
 * 格式化日期
 */
export const dateFormat = function () {
  /* eslint-disable no-extend-native */
  Date.prototype.format = function (fmt) {
    let o = {
      "M+": this.getMonth() + 1, // 月份
      "d+": this.getDate(), // 日
      "h+": this.getHours(), // 小时
      "m+": this.getMinutes(), // 分
      "s+": this.getSeconds(), // 秒
      "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
      S: this.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (this.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
      }
    }
    return fmt;
  };
};
// js判断两个时间戳是否同一天
export const isSameDay = (time, time1) => {
  return new Date(time).toDateString() === new Date(time1).toDateString();
};
//比较两个时间的大小
export const compareDate = (date, date1) => {
  date = new Date(date);
  date1 = new Date(date1);
  if (date.getTime() - date1.getTime() < 0) {
    return "towBig";
  } else {
    return "oneBig";
  }
};
